module.exports = __webpack_public_path__ + "img/scjb.a999913f.jpg";